type Props = {
	title?: string;
	message?: string;
};

export default function Loader({ title, message }: Props) {
	return (
		<div className="d-flex flex-column justify-content-center align-items-center vh-100">
			<div className="spinner-border" role="status">
				<span className="sr-only">{title || "Loading..."}</span>
			</div>
			<div className="mt-2">{message || "Uploading..."}</div>
		</div>
	);
}
